module.exports = __webpack_public_path__ + "static/media/logo.ffa59e2f.svg";